/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_5_TitleInputs */

const en_gc_search_guides_what_is_gridcraft_sections_5_title = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A concrete example: plan a small workshop`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_5_title = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`具体示例：规划一场小型工作坊`)
};

/**
* | output |
* | --- |
* | "A concrete example: plan a small workshop" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_5_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_5_title = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_5_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_5_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_5_title(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_5_title(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_5_title as "gc.search_guides.what_is_gridcraft.sections.5.title" }